<ng-container *ngIf="user.lastLogin">
  <span> {{ prefix }}{{ user.lastLogin | fsFormatDate : dateFormat }} </span>
</ng-container>

<ng-container *ngIf="!user.lastLogin">
  <span class="access-unknown-label"> {{ 'users.accessUnknown' | t }} </span>
</ng-container>
